const FieldValidate = (values: any) => {
  const warning: any = {};

  const emailFields = Object.keys(values).filter((key) =>
    key.startsWith("email")
  );
  emailFields.forEach((field) => {
    const email = values[field]?.email;
    const emailType = values[field]?.emailType;
    const isPrimary = values[field]?.isPrimary;
    if (email) {
      if (!emailType) {
        warning[field] = { ...warning[field], emailType: "Required" };
      }
    }
    if (emailType) {
      if (!email) {
        warning[field] = { ...warning[field], email: "Required" };
      }
    }
    if (isPrimary) {
      if (!email) {
        warning[field] = { ...warning[field], email: "Required" };
      }
      if (!emailType) {
        warning[field] = { ...warning[field], emailType: "Required" };
      }
    }
  });
  const phoneFields = Object.keys(values).filter((key) =>
    key.startsWith("phone")
  );
  phoneFields.forEach((field) => {
    const phone = values[field]?.phone;
    const phoneType = values[field]?.phoneType;
    const isPrimary = values[field]?.isPrimary;
    if (phone) {
      if (!phoneType) {
        warning[field] = { ...warning[field], phoneType: "Required" };
      }
    }
    if (phoneType) {
      if (!phone) {
        warning[field] = { ...warning[field], phone: "Required" };
      }
    }
    if (isPrimary) {
      if (!phone) {
        warning[field] = { ...warning[field], phone: "Required" };
      }
      if (!phoneType) {
        warning[field] = { ...warning[field], phoneType: "Required" };
      }
    }
  });
  return warning;
};

export default FieldValidate;
